export const COUNTRIES = [
  'Denmark', 'Sweden', 'Norway', 'Germany', 'Finland', 'China', 'India',
  'Poland', 'Vietnam', 'Italy', 'Netherlands', 'Turkey', 'Other',
];
